import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux'; 

import App from './App';
import { appConfig } from './app-config';
const store = createStore(() => [], {}, applyMiddleware());

ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter basename={appConfig.WEB_BASE_PATH}>
      <App/>
      </BrowserRouter>
    </Provider>,
  document.getElementById('root')
);
